import React from "react";
import { Calendar, Save, RotateCcw, GitBranch, Star, Edit3 } from "lucide-react";
import "./index.css";

interface HeaderProps {
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  resetAllToSuggested: () => void;
  handleSave: (mode: "update" | "new") => void;
  hasUnsavedChanges: boolean;
  selectedPlanId: string | null;
  selectedPlanData: any;
  isSaving: boolean;
  isUpdating: boolean;
}

const Header: React.FC<HeaderProps> = ({
  selectedDate,
  setSelectedDate,
  resetAllToSuggested,
  handleSave,
  hasUnsavedChanges,
  selectedPlanId,
  selectedPlanData,
  isSaving,
  isUpdating,
}) => {
  const isSaveInProgress = isSaving || isUpdating;

  return (
    <div className="allocation-header">
      <div className="allocation-header__top">
        <div className="allocation-header__left">
          <h1 className="allocation-header__title">Cart Allocation Pre Planning</h1>
          <p className="allocation-header__subtitle">
            Plan and allocate products to delivery carts
          </p>
          {selectedPlanId && (
            <div className="allocation-header__plan-indicator">
              <GitBranch className="allocation-header__plan-icon" />
              <span className="allocation-header__plan-text">
                Selected Plan: {selectedPlanData?.allocationPlanVersion}
              </span>
              {selectedPlanData?.isActive && (
                <Star className="allocation-header__active-icon" />
              )}
              {hasUnsavedChanges && (
                <span className="allocation-header__modified-indicator">
                  <Edit3 className="allocation-header__modified-icon" />
                  Modified
                </span>
              )}
            </div>
          )}
        </div>
        <div className="allocation-header__right">
          <div className="allocation-header__date-container">
            <Calendar className="allocation-header__date-icon" />
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="allocation-header__date-input"
              disabled={isSaveInProgress}
            />
          </div>
          <div className="allocation-header__actions">
            <button
              onClick={resetAllToSuggested}
              className="allocation-header__button allocation-header__button--secondary"
              disabled={isSaveInProgress}
            >
              <RotateCcw className="allocation-header__button-icon" />
              Reset All
            </button>

            {hasUnsavedChanges && (
              <div className="allocation-header__save-buttons">
                {selectedPlanId && (
                  <button
                    onClick={() => handleSave("update")}
                    className="allocation-header__button allocation-header__button--primary"
                    disabled={isSaveInProgress}
                  >
                    {isUpdating ? (
                      <>Saving...</>
                    ) : (
                      <>
                        <Save className="allocation-header__button-icon" />
                        Save
                      </>
                    )}
                  </button>
                )}
                <button
                  onClick={() => handleSave("new")}
                  className="allocation-header__button allocation-header__button--save-new"
                  disabled={isSaveInProgress}
                >
                  {isSaving ? (
                    <>Saving...</>
                  ) : (
                    <>
                      <Save className="allocation-header__button-icon" />
                      Save as New
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;